"use strict";

document.addEventListener('DOMContentLoaded', function() {

	var adpPopup = {};

	( function() {
		var $this;

		adpPopup = {
			sPrevious : window.scrollY,
			sDirection: 'down',

			/*
			* Initialize
			*/
			init: function( e ) {
				$this = adpPopup;

				$this.popupInit( e );

				// Init events.
				$this.events( e );
			},

			/*
			* Events
			*/
			events: function( e ) {
				document.addEventListener( 'click', function( e ) {
					var closeBtn = e.target.closest( '.popup-close' );
					if ( closeBtn ) {
						$this.closePopup( closeBtn );
						return;
					}

					var acceptBtn = e.target.closest( '.popup-accept' );
					if ( acceptBtn ) {
						$this.acceptPopup( acceptBtn );
						$this.closePopup( acceptBtn );
						return;
					}

					var ageCloseBtn = e.target.closest( '.age-verification__popup-close' );
					if ( ageCloseBtn ) {
						$this.agePopup( ageCloseBtn );
						$this.closePopup( ageCloseBtn );
						return;
					}

					if ( e.target.closest( '.age-verification__button-no' ) ) {
						$this.ageDeclined();
						return;
					}

					if ( e.target.closest( '.popup-overlay' ) ) {
						document.querySelectorAll( '.popup-open[data-overlay-close="true"]' ).forEach( function( popup ) {
							$this.closePopup( popup );
						} );
					}
				} );

				// Checking this will cause popup to close when user presses key.
				document.addEventListener( 'keyup', function( e ) {
					// Press ESC to Close.
					if ( e.key === 'Escape' ) {
						document.querySelectorAll( '.popup-open[data-esc-close="true"]' ).forEach( function( popup ) {
							$this.closePopup( popup );
						} );
					}

					// Press F4 to Close.
					if ( e.key === 'F4' ) {
						document.querySelectorAll( '.popup-open[data-f4-close="true"]' ).forEach( function( popup ) {
							$this.closePopup( popup );
						} );
					}
				} );
			},

			/*
			* Init popup elements
			*/
			popupInit: function( e ) {

				// Set scroll direction.
				document.addEventListener( 'scroll', function() {

					let scrollCurrent = window.scrollY;

					// Set scroll temporary vars.
					if ( scrollCurrent > $this.sPrevious ) {
						$this.sDirection = 'down';
					} else {
						$this.sDirection = 'up';
					}

					$this.sPrevious = scrollCurrent;
				} );

				// Open popup
				document.querySelectorAll( '.popup' ).forEach( function( popup ) {

					// Manual Launch.
					if ( 'manual' === popup.dataset.openTrigger ) {

						let selector = popup.dataset.openManualSelector;

						if ( selector ) {
							document.querySelectorAll( selector ).forEach( function( el ) {
								el.classList.add( 'popup-trigger' );
							} );

							document.addEventListener( 'click', function( e ) {
								var matchedEl = e.target.closest( selector );
								if ( ! matchedEl ) return;

								e.preventDefault();

								popup.classList.remove( 'popup-already-opened' );

								$this.openPopup( popup );

								if ( matchedEl.classList.contains( 'popup' ) ) {
									$this.closePopup( selector );
								}
							} );
						}
					}

					// Checks whether a popup should be displayed or not.
					if ( ! $this.isAllowPopup( popup ) && ! popup.classList.contains( 'age-verification' ) ) {
						return;
					}

					$this.openTriggerPopup( popup );
				} );
			},

			/*
			* Trigger open popup
			*/
			openTriggerPopup: function( popup ) {

				var trigger = popup.dataset.openTrigger;

				// Age Verification.
				if ( 'none' === trigger ) {
					let ageVerification = $this.getCookie( 'popup-age-' + ( popup.dataset.id || 0 ) );

					if ( ! ageVerification )
						$this.openPopup( popup );
				}

				// Time Delay.
				if ( 'delay' === trigger ) {
					setTimeout( function() {

						$this.openPopup( popup );

					}, parseInt( popup.dataset.openDelayNumber ) * 1000 );
				}

				// Exit Intent.
				if ( 'exit' === trigger ) {
					var showExit = true;
					document.addEventListener( 'mousemove', function( e ) {
						// Get current scroll position
						var scroll = window.pageYOffset || document.documentElement.scrollTop;
						if ( ( e.pageY - scroll ) < 7 && showExit ) {
							$this.openPopup( popup );
							showExit = false;
						}
					} );
				}

				// Scroll Position.
				if ( 'scroll' === trigger ) {

					var pointScrollType     = popup.dataset.openScrollType;
					var pointScrollPosition = parseFloat( popup.dataset.openScrollPosition );

					// Event scroll.
					document.addEventListener( 'scroll', function() {

						// Type px.
						if ( 'px' === pointScrollType ) {

							if ( window.scrollY >= pointScrollPosition ) {
								$this.openPopup( popup );
							}
						}

						// Type %.
						if ( '%' === pointScrollType ) {

							if ( $this.getScrollPercent() >= pointScrollPosition ) {
								$this.openPopup( popup );
							}
						}
					} );
				}

				// Accept Agreement.
				if ( 'accept' === trigger ) {
					let accept = $this.getCookie( 'popup-accept-' + ( popup.dataset.id || 0 ) );

					if ( ! accept ) {
						$this.openPopup( popup );
					}
				}
			},

			/*
			* Trigger close popup
			*/
			closeTriggerPopup: function( popup ) {

				var trigger = popup.dataset.closeTrigger;

				// Time Delay.
				if ( 'delay' === trigger ) {
					setTimeout( function() {

						$this.closePopup( popup );

					}, parseInt( popup.dataset.closeDelayNumber ) * 1000 );
				}

				// Scroll Position.
				if ( 'scroll' === trigger ) {

					var pointScrollType     = popup.dataset.closeScrollType;
					var pointScrollPosition = parseFloat( popup.dataset.closeScrollPosition );

					// Event scroll.
					document.addEventListener( 'scroll', function() {

						var initScrollPx      = parseFloat( popup.dataset.initScrollPx );
						var initScrollPercent = parseFloat( popup.dataset.initScrollPercent );

						// Type px.
						if ( 'px' === pointScrollType ) {

							if ( 'up' === $this.sDirection && window.scrollY < ( initScrollPx - pointScrollPosition ) ) {
								$this.closePopup( popup );
							}

							if ( 'down' === $this.sDirection && window.scrollY >= ( initScrollPx + pointScrollPosition ) ) {
								$this.closePopup( popup );
							}
						}

						// Type %.
						if ( '%' === pointScrollType ) {

							if ( 'up' === $this.sDirection && $this.getScrollPercent() < ( initScrollPercent - pointScrollPosition ) ) {
								$this.closePopup( popup );
							}

							if ( 'down' === $this.sDirection && $this.getScrollPercent() >= ( initScrollPercent + pointScrollPosition ) ) {
								$this.closePopup( popup );
							}
						}
					} );
				}
			},

			/*
			* Open popup
			*/
			openPopup: function( popup ) {

				// Hide body scroll.
				if ( popup.matches( '[data-body-scroll-disable="true"]' ) ) {
					document.body.classList.add( 'popup-scroll-hidden' );
				}

				// Set Cookie of Limit display.
				let limit = parseInt( $this.getCookie( 'popup-' + popup.dataset.id ) || 0 ) + 1;

				$this.setCookie( 'popup-' + popup.dataset.id, limit, {
					expires: popup.dataset.limitLifetime
				} );

				if ( popup.classList.contains( 'popup-open' ) ) {
					return;
				}

				// Check already opened.
				if ( popup.classList.contains( 'popup-already-opened' ) ) {
					return;
				}

				// Display popup.
				popup.classList.add( 'popup-open' );

				// Set current scroll.
				popup.dataset.initScrollPx      = window.scrollY;
				popup.dataset.initScrollPercent = $this.getScrollPercent();

				// Open animation.
				let animation = popup.dataset.openAnimation;

				$this.applyAnimation( popup, animation );

				// Init close trigger.
				$this.closeTriggerPopup( popup );
			},

			/*
			* Age popup
			*/
			agePopup: function( el ) {

				// Get popup container.
				let popup = el.closest( '.popup' );

				// Set Cookie of Age.
				$this.setCookie( 'popup-age-' + popup.dataset.id, 1, {
					expires: 360
				} );
			},

			/*
			* Age declined
			*/
			ageDeclined: function() {
				document.querySelectorAll( '.age-verification__question' ).forEach( function( el ) {
					el.classList.remove( 'show' );
				} );
				document.querySelectorAll( '.age-verification__declined' ).forEach( function( el ) {
					el.classList.add( 'show' );
				} );
			},

			/*
			* Accept popup
			*/
			acceptPopup: function( el ) {

				// Get popup container.
				let popup = el.closest( '.popup' );

				// Set Cookie of Accept.
				$this.setCookie( 'popup-accept-' + popup.dataset.id, 1, {
					expires: 360
				} );
			},

			/*
			* Close popup
			*/
			closePopup: function( el ) {

				// Get popup container.
				let popup;
				if ( typeof el === 'string' ) {
					var target = document.querySelector( el );
					popup = target ? target.closest( '.popup' ) : null;
				} else {
					popup = el.closest ? el.closest( '.popup' ) : el;
				}

				if ( ! popup ) return;

				// Close animation.
				let animation = popup.dataset.exitAnimation;

				$this.applyAnimation( popup, animation, function() {
					// Already opened.
					popup.classList.add( 'popup-already-opened' );

					// Hide popup.
					popup.classList.remove( 'popup-open' );

					// Remove classes from body.
					document.body.classList.remove( 'popup-scroll-hidden' );
				} );
			},

			/*
			* Checks whether a popup should be displayed or not
			*/
			isAllowPopup: function( popup ) {

				// Has user seen this popup before?
				let limitDisplay = parseInt( popup.dataset.limitDisplay || 0 );

				let limitDisplayCookie = parseInt( $this.getCookie( 'popup-' + popup.dataset.id ) );

				if ( limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay ) {
					return;
				}

				return true;
			},

			/*
			* Apply animation
			*/
			applyAnimation: function( el, name, callback ) {
				var popup = el.closest ? el.closest( '.popup' ) : el;

				if ( typeof callback === 'function' ) {
					var overlayName = 'popupExitFade';
				} else {
					var overlayName = 'popupOpenFade';
				}

				// Overlay Animation.
				var overlay = popup.nextElementSibling;
				if ( overlay && overlay.classList.contains( 'popup-overlay' ) ) {
					overlay.classList.add( 'popup-animated', overlayName );
					overlay.addEventListener( 'animationend', function() {
						overlay.classList.remove( 'popup-animated', overlayName );
					}, { once: true } );
				}

				// Wrap Animation.
				var wrap = popup.querySelector( '.popup-wrap' );
				if ( wrap ) {
					wrap.classList.add( 'popup-animated', name );
					wrap.addEventListener( 'animationend', function() {
						// remove the animation classes after animation ends
						// required in order to apply new animation on close
						wrap.classList.remove( 'popup-animated', name );

						if ( typeof callback === 'function' ) {
							callback();
						}
					}, { once: true } );
				}
			},

			/*
			* Get cookie
			*/
			getCookie: function( name ) {
				var matches = document.cookie.match( new RegExp(
					"(?:^|; )" + name.replace( /([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1' ) + "=([^;]*)"
				) );
				return matches ? decodeURIComponent( matches[ 1 ] ) : undefined;
			},

			/*
			* Set cookie
			*/
			setCookie: function( name, value, options ) {
				options = options || {};

				options.path = options.hasOwnProperty( 'path' ) ? options.path : '/';

				options.expires = parseInt( options.expires );

				if ( typeof options.expires == "number" && options.expires ) {

					options.expires = new Date().setDate(new Date().getDate() + options.expires );

					options.expires = new Date(options.expires).toUTCString();
				}

				value = encodeURIComponent( value );

				var updatedCookie = name + "=" + value;

				for ( var propName in options ) {
					updatedCookie += "; " + propName;
					var propValue = options[ propName ];
					if ( propValue !== true ) {
						updatedCookie += "=" + propValue;
					}
				}

				document.cookie = updatedCookie;
			},

			/*
			* Get scroll percent
			*/
			getScrollPercent: function() {
				var h = document.documentElement,
					b = document.body,
					st = 'scrollTop',
					sh = 'scrollHeight';
				return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
			}
		};

	} )();

	// Initialize.
	adpPopup.init();

	document.addEventListener('shopify:section:load', function () {
		adpPopup.init();
	});

	document.addEventListener('shopify:section:unload', function () {
		document.body.classList.remove( 'popup-scroll-hidden' );
	});
});